import { getCurrentUserDatas } from "./software";
import { GetIsFTVAChrome } from "./software";



var localHost  = "?";
var useLocalServer = false;

export function initlocalhost()
{

    // cas free est en panne
    if (useLocalServer) 
    {
        localHost =  "http://192.168.1.155:9083/";
        return;
    }

    if (window.location.hostname === "otto.myotto.fr")
        localHost  = "https://apiotto.myotto.fr/";
    else
        localHost  = "https://ottoapis.easydirect.fr/";

}

//https://datasotto.myotto.fr/chromium/Setup_FTVA_Chromium_150.msi

export function getlocalhostDatas()
{

    if (useLocalServer) return "http://192.168.1.155:4001/";

    if (window.location.hostname === "otto.myotto.fr")
        return "https://datasotto.myotto.fr/";
    else
        return  "https://ottodatas.easydirect.fr/";
}


export function getDocumentPath (asset)
{
    return getlocalhostDatas()+"documents/" + asset.asfile + "." + asset.asext;
}

export function getVideoPath (video)
{
    
    var videofile = video.vifile + "/" + video.vifile+"." + video.viext; // fichier original

    if (video.viconv === -3 )
        videofile = video.vifile + "/" + video.viconvfile +".mp4";
    
    videofile  = getlocalhostDatas()+"videos/" + videofile;

    return videofile;

}

export function getCpPaths(video)
{
    if (video.vixcp != -3)
    {
        return {json:"", jpegs:""};
    }
    var jsonfile = video.vifile+"/"+video.vixcpfile +"_cp.json";
    var jpegsfile = video.vifile+"/"+video.vixcpfile +"_cp.jpegs";


    jsonfile  = getlocalhostDatas()+"videos/" + jsonfile;
    jpegsfile  = getlocalhostDatas()+"videos/" + jpegsfile;

    return {json:jsonfile, jpegs:jpegsfile};
}

export function getAudioPath (channel,video)
{

    if (video.vixaudio != -3) return "";
    if (video.vinbaudio < channel ) return "";
    


    var audiofile = video.vifile+"/"+video.vixaudiofile1 +"_1.wf";
    if (channel == 2)
        audiofile = video.vifile+"/"+video.vixaudiofile2 +"_2.wf";

    audiofile  = getlocalhostDatas()+"videos/" + audiofile;
    return audiofile;

}

function getCurrentDate()
{
    const today = new Date();

    const year = today.getFullYear(); // Année AAAA
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Mois (01-12)
    const day = String(today.getDate()).padStart(2, '0'); // Jour (01-31)

    return `${year}/${month}/${day}`;
};


function getUserToken()
{

    var userdatas = localStorage.getItem("userdatas");
    
    if (userdatas != null)
    try
    { 
        userdatas = JSON.parse(userdatas);
        userdatas = userdatas.token;
    }
    catch(e)
    {
        
        userdatas = null;
    }
    return userdatas;

}

export function apiGetSsoUserDatasOrCreate(user, callback)
{
    var datas = {
        NameID: user.NameID,
        displayName: user.displayName
    }

        var myHeaders = new Headers();

        myHeaders.append('Accept','application/json');
        myHeaders.append('Content-Type','application/json');
        var myInit = { method: 'POST',
                headers: myHeaders,
                mode: 'cors',
                cache: 'default',
                body: JSON.stringify(datas)
                    };

        var apiurl = localHost + "getssousertoken";

        

        fetch(apiurl,myInit)
        .then((response) => {
        if (!response.ok) 
        {
            if (callback !== null) callback(null);
        }

        return response.json();
    })
    .then((actualData) => {
        if (callback !== null) callback(actualData);

    })
    .catch((err) => {
        if (callback !== null) callback(null);
    
    });

}

export function apiGetUserDatas (email,pwd, callback)
{

    var datas = {
        mail: email.toLowerCase(),
        password : pwd,
        }
        var myHeaders = new Headers();

        myHeaders.append('Accept','application/json');
        myHeaders.append('Content-Type','application/json');
        var myInit = { method: 'POST',
                headers: myHeaders,
                mode: 'cors',
                cache: 'default',
                body: JSON.stringify(datas)
                    };

        var apiurl = localHost + "getusertoken";

        
        

        fetch(apiurl,myInit)
        .then((response) => {
        if (!response.ok) 
        {
            if (callback !== null) callback(null);
        }

        return response.json();
    })
    .then((actualData) => {
        if (callback !== null) callback(actualData);

    })
    .catch((err) => {
        if (callback !== null) callback(null);
    
    });

}
//  *************************************************************************************************************
//  * function API GET DE BASE
// **************************************************************************************************************
function apiGet (sd, callback)
{

    
    var myHeaders = new Headers();
    myHeaders.append('Authorization', getUserToken());

    var myInit = { method: 'GET',
                headers: myHeaders,
                mode: 'cors',
                cache: 'default' };

    var apiurl = localHost + sd;
 
    fetch(apiurl,myInit)
    .then((response) => {
    if (!response.ok) {
        if (callback !== null) callback(null);
    }
    
    return response.json();
    })
    .then((actualData) => {

        if (callback !== null) callback(actualData);
    })
    .catch((err) => {
        if (callback !== null) callback(null);
    });    
}

//  *************************************************************************************************************
//  * function API POST DE BASE
// **************************************************************************************************************
function apiPost (sd, datas, callback, nojson=false)
{
        var myHeaders = new Headers();

        if (!nojson)
        {
            myHeaders.append('Accept','application/json');
            myHeaders.append('Content-Type','application/json');
        }
        myHeaders.append('Authorization', getUserToken());

        var myInit = { method: 'POST',
                headers: myHeaders,
                mode: 'cors',
                cache: 'default',
        };

        if (nojson)
            myInit.body = datas;
        else
            myInit.body = JSON.stringify(datas);

        var apiurl = localHost + sd;


        fetch(apiurl,myInit)
        .then((response) => {
        if (!response.ok) 
        {

            if (callback !== null) callback({ret:false});
            return;
        }

        return response.json();
    })
    .then((actualData) => {

        if (callback !== null) callback(actualData);

    })
    .catch((err) => {
        console.log(err)
        if (callback !== null) callback({ret:false});
    
    });

}


//  *************************************************************************************************************
//  * function API DELETE DE BASE
// **************************************************************************************************************
function apiDelete (sd, datas, callback)
{
        var myHeaders = new Headers();

        myHeaders.append('Accept','application/json');
        myHeaders.append('Content-Type','application/json');
        myHeaders.append('Authorization', getUserToken());

        var myInit = { method: 'DELETE',
                headers: myHeaders,
                mode: 'cors',
                cache: 'default',
        };
        myInit.body = JSON.stringify(datas);
        var apiurl = localHost + sd;
        fetch(apiurl,myInit)
        .then((response) => {
        if (!response.ok) 
        {
            if (callback !== null) callback({ret:false});
            return;
        }
        return response.json();
    })
    .then((actualData) => {
        if (callback !== null) callback(actualData);

    })
    .catch((err) => {
        console.log(err)
        if (callback !== null) callback({ret:false});
    
    });
}

//  *************************************************************************************************************
//  * function API PUT DE BASE
// **************************************************************************************************************
function apiPut (sd, datas, callback)
{
        var myHeaders = new Headers();

        myHeaders.append('Accept','application/json');
        myHeaders.append('Content-Type','application/json');
        myHeaders.append('Authorization', getUserToken());

        var myInit = { method: 'PUT',
                headers: myHeaders,
                mode: 'cors',
                cache: 'default',
        };
        myInit.body = JSON.stringify(datas);
        var apiurl = localHost + sd;
        fetch(apiurl,myInit)
        .then((response) => {
        if (!response.ok) 
        {
            if (callback !== null) callback({ret:false});
            return;
        }
        return response.json();
    })
    .then((actualData) => {
        if (callback !== null) callback(actualData);

    })
    .catch((err) => {
        console.log(err)
        if (callback !== null) callback({ret:false});
    
    });
}

//  *************************************************************************************************************
//  * API USERS 
// **************************************************************************************************************

export function apiGetUserList (callback)
{
    apiGet("getusers", callback);
}

export function apiGetShortUserList (callback)
{
    apiGet("getshortusers", callback);
}

export function apiDeleteUser(userid, callback)
{
    apiPost("deleteuser", {userid: userid}, callback)
}

export function apiCreateUserDatas(datas, callback)
{
    apiPost ("createuser", datas, callback);
}


export function apiWriteUserDatas ( datas, callback)
{
    apiPost ("updateuser", datas, callback);
}

export function apiSaveUserConfig ( datas, callback)
{
    apiPost ("updateconfiguser", datas, callback);
}

export function apiSaveUserOptions(datas, callback)
{
    const finaldatas = {
        id: getCurrentUserDatas().id,
        options: JSON.stringify(datas),
    }

    console.log("final datas", finaldatas)

    apiPost ("updateoptionsuser", finaldatas, callback);
}

export function apiSaveUserKeyboard(datas, callback)
{
    const finaldatas = {
        id: getCurrentUserDatas().id,
        values: JSON.stringify(datas),
    } 

    console.log("final datas", finaldatas)

    if (GetIsFTVAChrome()=="")
        apiPost ("updatekeyboarduser", finaldatas, callback);
    else
        apiPost ("updatekeyboardchromiumuser", finaldatas, callback);
}


//  *************************************************************************************************************
//  * API UPLOAD 
// **************************************************************************************************************
export function apiUploadSendChunk(filename, filesize,chunk, chunkIndex, chunkSize,  totalChunks,callback)
{

    var json = {
        filename: filename,
        chunkindex: chunkIndex,
        //totalchunks: Math.ceil(totalChunks),
        //filesize: filesize,
        chunksize: chunkSize,

    }

    const formData = new FormData();
    formData.append ('json', JSON.stringify(json));
    formData.append('chunk', chunk);
    apiPost("uploadfile", formData, callback, true);
  }


//  *************************************************************************************************************
//  * API CLIENTS
// **************************************************************************************************************
export function apiCreateClients ( datas, callback)
{
    
    apiPost ("table/clients", datas, callback);
}
export function apiGetClientsList (callback)
{
    apiGet("table/clients", callback);
}
export function apiDeleteClients ( datas, callback)
{
    
    apiDelete ("table/clients", datas, callback);
}

export function apiUpdateClients ( datas, callback)
{
    
    apiPut ("table/clients", datas, callback);
}


//  *************************************************************************************************************
//  * API DIFFUSORS
// **************************************************************************************************************
export function apiCreateDiffusors ( datas, callback)
{
    
    apiPost ("table/diffusors", datas, callback);
}
export function apiGetDiffusorsList (callback)
{
    apiGet("table/diffusors", callback);
}
export function apiDeleteDiffusors ( datas, callback)
{
    
    apiDelete ("table/diffusors", datas, callback);
}

export function apiUpdateDiffusors ( datas, callback)
{
    
    apiPut ("table/diffusors", datas, callback);
}


//  *************************************************************************************************************
//  * API Series
// **************************************************************************************************************
export function apiCreateSeries ( datas, callback)
{
    
    apiPost ("table/series", datas, callback);
}
export function apiGetSeriesList (callback)
{
    apiGet("table/series", callback);
}
export function apiDeleteSeries ( datas, callback)
{
    
    apiDelete ("table/series", datas, callback);
}

export function apiUpdateSeries ( datas, callback)
{
    
    apiPut ("table/series", datas, callback);
}

//  *************************************************************************************************************
//  * API Project
// **************************************************************************************************************
export function apiCreateProjects ( datas, callback)
{
    apiPost ("table/projects", datas, callback);
}

export function apigetProjectsListByUser ( user, callback)
{
    apiPost ("table/getprojectsbyuser", {userid:user}, callback);
}


export function apiGetSearchProjects(datas, callback)
{
    apiPost ("table/searchprojects", datas, callback);
}

export function apiGetOneProject(datas, callback)
{
    apiPost ("table/readoneproject", datas, callback);
}


export function apiGetProjectsList (callback)
{
    apiGet("table/projects", callback);
}

export function apiDeleteProjects ( datas, callback)
{
    
    apiDelete ("table/projects", datas, callback);
}

export function apiUpdateProjects ( datas, callback)
{
    
    apiPut ("table/projects", datas, callback);
}
export function apiChangeProjectUser ( datas, callback)
{
    
    apiPost ("table/changeprojectuser", datas, callback);
}

//  *************************************************************************************************************
//  * API Assets
// **************************************************************************************************************
export function apiGetAllChildsSubtitleAssets(datas, callback)
{
    apiPost("/table/getsubtitlesparents", datas, callback);
}
export function apiSearchAssetsFromProject(datas, callback)
{
    
    apiPost ("/table/searchassets", datas, callback);
}

export function apiSearchSubtitlesAssetsFromProject(pjid, callback)
{
    apiPost ("/table/subtitleslist", {pjid:pjid}, callback);
}



export function apiCreateOneAsset ( datas, callback)
{
    
    apiPost ("table/assets", datas, callback);
}
export function apiCreateFromAsset ( datas, callback)
{
    
    apiPost ("table/copyassets", datas, callback);
}
export function apiReadOneAsset ( datas, callback)
{
    
    apiPost ("table/readoneasset", datas, callback);
}
export function apiDeleteAsset ( datas, callback)
{
    
    apiDelete ("table/assets", datas, callback);
}

export function apiSetNewTimeCodeAsset (datas, callback)
{
    apiPut("table/setnewtimecodeasset", datas, callback)
}
export function apiUpdateAsset ( datas, callback)
{
    
    apiPut ("table/assets", datas, callback);
}

export function apiSaveAsset ( datas, callback)
{
    
    apiPut ("table/saveassets", datas, callback);
}

export function apiSaveFileDirect ( datas, callback)
{
    apiPut ("table/savefiledirect", datas, callback);
}

//  *************************************************************************************************************
//  * Miscellianous API
// **************************************************************************************************************
// Lecture de la liste des languages
export function apiGetLanguagesList (callback)
{
    
    apiGet("miscellianous/languages", callback);
}

//  *************************************************************************************************************
//  * Configurations Api
// **************************************************************************************************************

/* retour: 
    {
        ret: true/false,
        id: id asset,
        msg: "ok",
    }
*/



export function apiCreateConfiguration ( datas, callback)
{
    
    /* datas = 
    {   
        
        coname: "",
        coclid: clid, // peut être = 0
        codiid: diif, // peut être = 0
        cotype: type // 0 = toutes 1 = classique 2 = teletexte
        codatas: JSON.stringify(stprams)
    }
    */
    // on ajoute aussi la date de création
    datas.coid = 0; // doit être présent mais non utilisé
    datas.cocreatedate  = getCurrentDate();
    datas.coupdatedate = ""; // not use but must be set
    
    apiPost ("table/configurations", datas, callback);
}
export function apiGetConfigurationsList (callback)
{
    // retourne array de configurations trié par coname
    apiGet("table/configurations", callback);
}
export function apiDeleteConfiguration ( datas, callback)
{
    /* datas = {coid:id} */
    apiDelete ("table/configurations", datas, callback);
}

export function apiUpdateConfiguration ( datas, callback)
{
    /* datas = 
    {   
        coid: id, // doit être renseigné
        coname: "",
        coclid: clid,
        codiid: diif,
        cotype: type // 0 = toutes 1 = classique 2 = teletexte
        codatas: JSON.stringify(stprams)
    }
    */
   
    // on ajoute la date de modification
    datas.cocreatedate  = ""; // non utilisé mais doit être présent
    datas.coupdatedate  = getCurrentDate(); // 
    
    apiPut ("table/configurations", datas, callback);
}
export function apiReadOneConfiguration (coid, callback)
{
    const datas = 
    {
        coid: coid,
        cotype:0,
        coclid:0,
        codiid:0,
    }
    apiSearchConfiguration (datas, callback);
}
export function apiSearchConfiguration (datas, callback)
{
    /* datas = 
    {   
        coid: id, 0 ou numéro
        coclid: clid,
        codiid: diif,
        cotype: type // 0 = toutes 1 = classique 2 = teletexte
    }
    */
    apiPost("table/searchconfigurations", datas, callback)
}

export function apiSetAssetConfiguration (datas, callback)
{
    /* datas = 
    {   
        asid: asset id
        coid: id, 0 ou numéro
    }
    */
   apiPost("table/setassetconfiguration", datas, callback)

}


//  *************************************************************************************************************
//  * SEQUENCES API
// **************************************************************************************************************
export function apiCreateSequences (datas, callback)
{
    
    apiPost("/sequences/createsequencefromvideo", datas, callback);
}



//  *************************************************************************************************************
//  * VIDEOS API
// **************************************************************************************************************
// Création d'une nouvelle vidéo...
export function apiCreateNewVideoFromUpload (datas, callback)
{
    
    apiPost("/videos/createfromupload", datas, callback);
}

export function apiReadOneVideo (datas, callback)
{
    
    apiPost("/videos/readonevideo", datas, callback);
}

export function ApiUpdateAssetVideo(datas, callback)
{
    
    apiPut("/videos/updateasset", datas, callback)
}

export function ApiDeleteAssetVideo(datas, callback)
{
    
    apiDelete("/videos/deleteasset", datas, callback)
}

export function ApiGetVideoShortList(datas, callback)
{
    
    apiPost("/videos/videolist", datas, callback)
}

export function ApiPostSetTimeCodeVideo (datas, callback)
{
    // viid, time: xx:xx:xx:xx dropframe 0,1
    apiPost("/videos/timecode", datas, callback)
}

export function ApiPostKillWorker(datas, callback)
{
    
    apiPost("/miscellianous/killworker", datas, callback)
}

export function ApiPostRestartWorker(datas, callback)
{
    apiPost("/miscellianous/restartworker", datas, callback)
}

export function ApiPostToDoWorker(datas, callback)
{
    apiPost("/miscellianous/todoworker", datas, callback)
}

export function ApiPostCancelWorker(datas, callback)
{
    console.log("api post cancel ", datas)
    apiPost("/miscellianous/cancelworker", datas, callback)
}


//  *************************************************************************************************************
//  * API workerTask 
// **************************************************************************************************************
export function ApiWorkerTasksList(callback)
{
    const datas = {
        restart: false,
        wkid: 0,
        pjid: 0,
        viid: 0,
        userid: getCurrentUserDatas().id,
    }
    apiPost("/videos/getworkertasks", datas, callback)
}

export function ApiWorkerTaskDelete(viid, callback)
{
    const datas = {
        restart: false,
        wkid: 0,
        pjid: 0,
        viid: viid,
        userid: getCurrentUserDatas().id,
    }
    apiPost("/videos/changeworkertask", datas, callback)
}

export function ApiWorkerTaskRecreateOrUpdate(wkid, viid, pjid, callback)
{
    const datas = {
        restart: true,
        wkid: wkid,
        pjid: pjid,
        viid: viid,
        userid: getCurrentUserDatas().id,
    }
    apiPost("/videos/changeworkertask", datas, callback)
}

